import { useEffect, useState } from "react";
import { AnimatePresence, motion, useScroll, useSpring } from "framer-motion";
import { ArrowUp, MessageCircle } from "lucide-react";
import { useLenis } from "@/App";
import { CONTACT } from "@/data/services";

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="ribbon-gradient fixed inset-x-0 top-0 z-[120] h-[3px] origin-left"
      style={{ scaleX }}
    />
  );
}

export default function FloatingDock() {
  const [showTop, setShowTop] = useState(false);
  const lenis = useLenis();

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-[110] flex flex-col items-end gap-3 sm:bottom-8 sm:right-8" data-testid="floating-dock">
      <AnimatePresence>
        {showTop && (
          <motion.button
            type="button"
            data-testid="back-to-top"
            aria-label="Back to top"
            onClick={() => (lenis?.current ? lenis.current.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
            initial={{ opacity: 0, y: 12, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.8 }}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-ink/80 text-paper backdrop-blur-md transition-colors duration-300 hover:border-saffron hover:text-saffron"
          >
            <ArrowUp className="h-4 w-4" />
          </motion.button>
        )}
      </AnimatePresence>
      <motion.a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-ink shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)]"
      >
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40" />
        <MessageCircle className="relative h-6 w-6" />
        <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full border border-white/10 bg-ink/90 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper opacity-0 transition-opacity duration-300 group-hover:opacity-100 sm:block">
          WhatsApp Anuj · 99199 99647
        </span>
      </motion.a>
    </div>
  );
}
